import { useMutation } from "@tanstack/react-query";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IMember, ISelectMember } from "./types";

export function ApproveMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.approveMember}`, model),
  });
}

export function RejectMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.rejectMember}`, model),
  });
}

export function useDelete() {
  return useMutation({
    mutationFn: (id: number) =>
      api.get<number>(`${endpoints.member.delete}/${id}`),
  });
}

export function ApproveAllMembers() {
  return useMutation({
    mutationFn: (model: ISelectMember) =>
      api.post<number>(`${endpoints.member.approveallMembers}`, model),
  });
}

export function useAddMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.add}`, model),
  });
}

export function useEditMember() {
  return useMutation({
    mutationFn: (model: IMember) =>
      api.post<number>(`${endpoints.member.update}`, model),
  });
}

export function useImportMemberExcel() {
  return useMutation({
    mutationFn: (excel: File) => {
      const formData = new FormData();
      formData.append("file", excel);
      return api.upload<{ fileBytes: string; insertedCount: number }>(
        `${endpoints.member.importMemebrExcel}`,
        formData
      );
    },
  });
}
